import { Box, Button, Typography } from "@mui/material";
import { i18nFunction } from "src/careflow/ph-core/internationalization/hook/useLocales";

export const NonExistingInformation = ({i18n, closeDialog}: {i18n: i18nFunction, closeDialog: any}) => {
  return (
    <Box sx={{ m: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
        {i18n('case.details.workflow.nonExistingInformation.title', 'crs')}
      </Typography>
      <Typography gutterBottom>
        {i18n('case.details.workflow.nonExistingInformation.required', 'crs')}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {i18n('case.details.workflow.nonExistingInformation.details', 'crs')}
      </Typography>
      <Box sx={{ my: 2 }} display='flex' justifyContent='flex-end'>
        <Button 
          variant='contained' 
          onClick={() => closeDialog('this', null)}
        >
          {i18n('case.details.workflow.nonExistingInformation.close', 'crs')}
        </Button>
      </Box>
    </Box>
)};